import { TripInformationConstants } from './tripInformation.constants'
import { ITripInformationAction, ITripInformationState } from './tripInformation.types'

export const initialTripInformationState: ITripInformationState = {
  base: null,
  unit: null,
  staffingLevel: null,
  unitEquipment: null,
  shift: null,
  dispatchID: '',
  localId: '',
  registrationTailNumber: null,
  dispatchPriority: null,
  emdPerformed: null,
  emdPerformedPNNV: null,
  emd: '',
  typeofService: null,
  scheduled: null,
  standByPurpose: null,
  callType: null,
  patientCategory: null,
  dispatchedAs: null,
  disposition: null,
  unitDisposition: null,
  patientEvaluation: null,
  patientEvaluationPNNV: null,
  crewDisposition: null,
  crewDispositionPNNV: null,
  transportDisposition: null,
  transportDispositionPNNV: null,
  refusalReleaseReason: [],
  ambulanceTransportCode: null,
  massCasualty: null,
  massCasualtyPNNV: null,
  dispatchLocation: '',
  vehicleGPSN: '',
  vehicleGPSE: '',
  vehicleUSNG: '',
  vehicleGrid: null,
  vehicleMileageStart: '',
  vehicleMileageRef: '',
  vehicleMileageEnd: '',
  vehicleMileageRec: '',
  vehicleMileageLoaded: '',
  vehicleMileageTotal: '',
  lpm_lpm: 0,
  lpm_odom: 0,
  __unitOption: null,
  __baseOption: null,
  __regTailNumberOption: null,
  team: null,
  teamCareOnly: null,
  equipment: [],
  providerRoles: [],
  maxAlt: '',
  flightPlan: null,
}

export function tripInformationReducer(
  state: ITripInformationState = initialTripInformationState,
  action: ITripInformationAction
): ITripInformationState {
  switch (action.type) {
    case TripInformationConstants.NOT_IMPLEMENTED:
      alert('Not implemented')
      return state
    case TripInformationConstants.SET_BASE:
      return { ...state, base: action.base }
    case TripInformationConstants.SET_UNIT:
      return { ...state, unit: action.unit }
    case TripInformationConstants.SET_STAFFING_LEVEL:
      return { ...state, staffingLevel: action.staffingLevel }
    case TripInformationConstants.SET_UNIT_EQUIPMENT:
      return { ...state, unitEquipment: action.unitEquipment }
    case TripInformationConstants.SET_SHIFT:
      return { ...state, shift: action.shift }
    case TripInformationConstants.SET_DISPATCH_ID:
      return { ...state, dispatchID: action.dispatchID }
    case TripInformationConstants.SET_LOCAL_ID:
      return { ...state, localId: action.localId }
    case TripInformationConstants.SET_REGISTRATION_TAIL_NUMBER:
      return { ...state, registrationTailNumber: action.registrationTailNumber }
    case TripInformationConstants.SET_DISPATCH_PRIORITY:
      return { ...state, dispatchPriority: action.dispatchPriority }
    case TripInformationConstants.SET_EMD_PERFORMED:
      return { ...state, emdPerformed: action.emdPerformed }
    case TripInformationConstants.SET_EMD_PERFORMED_PNNV:
      return { ...state, emdPerformedPNNV: action.emdPerformedPNNV }
    case TripInformationConstants.SET_EMD:
      return { ...state, emd: action.emd }
    case TripInformationConstants.SET_TYPE_OF_SERVICE:
      return { ...state, typeofService: action.typeofService }
    case TripInformationConstants.SET_SCHEDULED:
      return { ...state, scheduled: action.scheduled }
    case TripInformationConstants.SET_STANDBY_PURPOSE:
      return { ...state, standByPurpose: action.standByPurpose }
    case TripInformationConstants.SET_CALL_TYPE:
      return { ...state, callType: action.callType }
    case TripInformationConstants.SET_PATIENT_CATEGORY:
      return { ...state, patientCategory: action.patientCategory }
    case TripInformationConstants.SET_DISPATCHED_AS:
      return { ...state, dispatchedAs: action.dispatchedAs }
    case TripInformationConstants.SET_DISPOSITION:
      return { ...state, disposition: action.disposition }
    case TripInformationConstants.SET_UNIT_DISPOSITION:
      return { ...state, unitDisposition: action.unitDisposition }
    case TripInformationConstants.SET_PATIENT_EVALUATION:
      return { ...state, patientEvaluation: action.patientEvaluation }
    case TripInformationConstants.SET_PATIENT_EVALUATION_PNNV:
      return { ...state, patientEvaluationPNNV: action.patientEvaluationPNNV }
    case TripInformationConstants.SET_CREW_DISPOSITION:
      return { ...state, crewDisposition: action.crewDisposition }
    case TripInformationConstants.SET_CREW_DISPOSITION_PNNV:
      return { ...state, crewDispositionPNNV: action.crewDispositionPNNV }
    case TripInformationConstants.SET_TRANSPORT_DISPOSITION:
      return { ...state, transportDisposition: action.transportDisposition }
    case TripInformationConstants.SET_TRANSPORT_DISPOSITION_PNNV:
      return { ...state, transportDispositionPNNV: action.transportDispositionPNNV }
    case TripInformationConstants.SET_REFUSAL_RELEASE_REASON:
      return { ...state, refusalReleaseReason: action.refusalReleaseReason }
    case TripInformationConstants.SET_AMBULANCE_TRANSPORT_CODE:
      return { ...state, ambulanceTransportCode: action.ambulanceTransportCode }
    case TripInformationConstants.SET_MASS_CASUALTY:
      return { ...state, massCasualty: action.massCasualty }
    case TripInformationConstants.SET_MASS_CASUALTY_PNNV:
      return { ...state, massCasualtyPNNV: action.massCasualtyPNNV }
    case TripInformationConstants.SET_DISPATCH_LOCATION:
      return { ...state, dispatchLocation: action.dispatchLocation }
    case TripInformationConstants.SET_VEHICLE_GPS_N:
      return { ...state, vehicleGPSN: action.vehicleGPSN }
    case TripInformationConstants.SET_VEHICLE_GPS_E:
      return { ...state, vehicleGPSE: action.vehicleGPSE }
    case TripInformationConstants.SET_VEHICLE_USNG:
      return { ...state, vehicleUSNG: action.vehicleUSNG }
    case TripInformationConstants.SET_VEHICLE_GRID:
      return { ...state, vehicleGrid: action.vehicleGrid }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_START:
      return { ...state, vehicleMileageStart: action.vehicleMileageStart }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_REF:
      return { ...state, vehicleMileageRef: action.vehicleMileageRef }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_END:
      return { ...state, vehicleMileageEnd: action.vehicleMileageEnd }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_REC:
      return { ...state, vehicleMileageRec: action.vehicleMileageRec }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_ODOM:
      return { ...state, lpm_odom: action.lpm_odom }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_LPM:
      return { ...state, lpm_lpm: action.lpm_lpm }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_LOADED:
      return { ...state, vehicleMileageLoaded: action.vehicleMileageLoaded }
    case TripInformationConstants.SET_VEHICLE_MILEAGE_TOTAL:
      return { ...state, vehicleMileageTotal: action.vehicleMileageTotal }
    case TripInformationConstants.SET_TEAM:
      return { ...state, team: action.team }
    case TripInformationConstants.SET_TEAM_CARE_ONLY:
      return { ...state, teamCareOnly: action.teamCareOnly }
    case TripInformationConstants.SET_EQUIPMENT:
      return { ...state, equipment: action.equipment }
    case TripInformationConstants.SET_PROVIDER_ROLES:
      return { ...state, providerRoles: action.providerRoles }
    case TripInformationConstants.SET_MAX_ALT:
      return { ...state, maxAlt: action.maxAlt }
    case TripInformationConstants.SET_FLIGHT_PLAN:
      return { ...state, flightPlan: action.flightPlan }
    case TripInformationConstants.SET_TRIP_INFORMATION:
      return { ...state, ...action.tripInformation }
    case TripInformationConstants.SET_UNIT_OPTION:
      return { ...state, __unitOption: action.__unitOption }
    case TripInformationConstants.SET_BASE_OPTION:
      return { ...state, __baseOption: action.__baseOption }
    case TripInformationConstants.SET_REG_TAIL_NUMBER_OPTION:
      return { ...state, __regTailNumberOption: action.__regTailNumberOption }
    case TripInformationConstants.RESET_TRIP_INFORMATION:
      return { ...initialTripInformationState }
    default:
      return state
  }
}
